<div class="c-switch-box{{#if active}} active{{/if}}" on-click="@this.toggle('active')">
	{{yield}}
</div>
